import React, { useState } from 'react';
import { Link } from 'gatsby';
import logo from '../../images/logo-final.png';
import TopLevel from './TopLevel';
import '../style.scss';
import './nav.scss';

const links = [
  {
    name: 'About',
    to: '/about',
    subMenuText: ['Introduction', 'Research', 'Leadership', 'FAQ'],
    subMenu: ['', 'research', 'leadership', 'faq'],
  },
  {
    name: 'Substance Use 101',
    to: '/one-oh-one',
    subMenuText: [
      'Rates of Teen Use',
      'Teen Brain Development',
      'Substance Use & the Brain',
      'Health Effects',
      'Signs & Symptoms of Addiction',
      'Industry Influence',
      'Better Addressing Substance Use as a Society',
    ],
    subMenu: [
      '',
      'development',
      'brain',
      'health',
      'signs',
      'industry',
      'society',
    ],
  },
  {
    name: 'Facilitators',
    to: '/facilitators',
    subMenuText: [
      'Introduction',
      'Facilitator Training Sign-ups',
      'Schools Enrolled in iDECIDE',
    ],
    subMenu: ['introduction', 'signups', 'schools'],
  },
  {
    name: 'Resources',
    to: '/resources',
    // subMenu: [
    //   'Teens',
    //   'Family',
    //   'Evidence-Based Practice & Trainings',
    //   'Education',
    //   'Help',
    //   'Massachusetts Statewide Resources',
    //   'Massachusetts Regional Resources',
    // ],
  },
  {
    name: 'News',
    to: '/news',
    subMenuText: ['Publications'],
    subMenu: ['publications'],
  },
  {
    name: 'Policy',
    to: '/policy',
  },
  {
    name: 'iCARE',
    to: '/icare',
  },
];

const semiBold = 'has-text-weight-semibold';
const navbarItem = `navbar-item ${semiBold} is-size-8 pop`;

const createLinks = (linksArr, openSubmenus, toggleSubmenu) => {
  return linksArr.map((link, i) => {
    const { subMenu, subMenuText, to, name } = link;
    const isSubmenuOpen = openSubmenus[name];
    return (
      <div className="navbar-item has-dropdown is-hoverable is-size-5" key={i}>
        <Link
          className={`link-nav navbar-item ${semiBold} is-hidden-mobile`}
          to={to}
        >
          {name}
        </Link>
        {subMenu && (
          <div
            className="nav-wide navbar-dropdown is-hidden-mobile tablet-hide is-boxed"
            style={{ overflow: 'hidden' }}
          >
            {subMenu.map((sub, i) => {
              if (sub === 'Log in') {
                return (
                  <a
                    href="https://lms.idecidemyfuture.org"
                    className={navbarItem}
                    key={i}
                  >
                    Log in
                  </a>
                );
              } else
                return (
                  <Link className={navbarItem} key={i} to={`${to}/${sub}`}>
                    {subMenuText?.[i] ??
                      sub.charAt(0).toUpperCase() + sub.slice(1)}
                  </Link>
                );
            })}
          </div>
        )}
        {/* Mobile navigation */}
        <div className="is-hidden-desktop">
          {subMenu ? (
            // For items with submenus - collapsible
            <>
              <div
                className="mobile-submenu-header navbar-item"
                onClick={() => toggleSubmenu(name)}
              >
                <span className={`mobile-submenu-title ${semiBold}`}>
                  {name}
                </span>
                <span
                  className={`mobile-submenu-arrow ${
                    isSubmenuOpen ? 'is-open' : ''
                  }`}
                >
                  ▼
                </span>
              </div>
              <div
                className={`mobile-submenu ${isSubmenuOpen ? 'is-open' : ''}`}
              >
                {subMenu.map((sub, i) => {
                  if (sub === 'Log in') {
                    return (
                      <a
                        href="https://lms.idecidemyfuture.org"
                        className="navbar-item mobile-submenu-item"
                        key={i}
                      >
                        Log in
                      </a>
                    );
                  } else
                    return (
                      <Link
                        className="navbar-item mobile-submenu-item"
                        key={i}
                        to={`${to}/${sub}`}
                      >
                        {subMenuText?.[i] ??
                          sub.charAt(0).toUpperCase() + sub.slice(1)}
                      </Link>
                    );
                })}
              </div>
            </>
          ) : (
            // For items without submenus - direct link
            <Link className={`mobile-nav-item navbar-item ${semiBold}`} to={to}>
              {name}
            </Link>
          )}
        </div>
      </div>
    );
  });
};

const NavMenu = () => {
  const [burgerActive, setBurgerActive] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});

  const toggleSubmenu = linkName => {
    setOpenSubmenus(prev => ({
      ...prev,
      [linkName]: !prev[linkName],
    }));
  };

  return (
    <div className={'has-background-white custom-is-fixed-top'}>
      <TopLevel />
      <nav className="navbar" role="navigation" aria-label="main navigation">
        <div className={`navbar-brand navbar-more ${semiBold}`}>
          <Link className="navbar-item" to="/">
            <img className="logo" alt="logo" src={logo} />
          </Link>
          <button
            onClick={() => setBurgerActive(!burgerActive)}
            className={`button is-link is-size-5 ${semiBold} navbar-burger ${burgerActive &&
              'is-active'}`}
            aria-label="menu"
            aria-expanded="false"
          >
            <span
              aria-hidden="true"
              className={`${burgerActive && 'is-active'} burgers`}
            ></span>
            <span
              aria-hidden="true"
              className={`${burgerActive && 'is-active'} burgers`}
            ></span>
            <span
              aria-hidden="true"
              className={`${burgerActive && 'is-active'} burgers`}
            ></span>
          </button>
        </div>
        <div className={`navbar-menu ${burgerActive ? 'is-active' : null}`}>
          <div className="navbar-start"></div>
          <div className="navbar-end">
            {createLinks(links, openSubmenus, toggleSubmenu)}
            <div className="navbar-item">
              <div className="buttons">
                <a
                  href="https://lms.idecidemyfuture.org"
                  className={`button is-light ${semiBold} has-text-white has-background-primary`}
                >
                  Log in
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavMenu;
